import { render, staticRenderFns } from "./InfoTile.vue?vue&type=template&id=5fc59fec&scoped=true&lang=pug"
import script from "./InfoTile.vue?vue&type=script&lang=ts"
export * from "./InfoTile.vue?vue&type=script&lang=ts"
import style0 from "./InfoTile.vue?vue&type=style&index=0&id=5fc59fec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc59fec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VSkeletonLoader})
